import FacebookLogin from '@greatsumini/react-facebook-login';
import { SocialButtonProps } from '../../type';
import { FacebookSvg } from '../../icons';

const isSecureEnoughForFacebookSDK = (): boolean => {
  if (typeof window === 'undefined' || !window.location) return false;
  const { protocol, hostname } = window.location;
  // Facebook JS SDK FB.getLoginStatus / login() yêu cầu https:// kể từ FB Graph v9+.
  // Local development cho phép http://localhost / http://127.0.0.1 (FB SDK vẫn hoạt động).
  // Tất cả các origin http khác (vd local IP LAN 192.168.x.x / host http staging) ->
  // FB SDK sẽ log warning: "The method FB.getLoginStatus can no longer be called from
  // http pages." nên chúng ta KO render FacebookLogin component (KO inject SDK script)
  // để tránh spam console log mỗi khi App re-render (login / logout / register).
  if (protocol === 'https:') return true;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return true;
  if (hostname.endsWith('.localhost')) return true;
  return false;
};

export default function FacebookLoginButton({ facebookAppId = '', onSuccess, onError }: SocialButtonProps) {
  const secure = isSecureEnoughForFacebookSDK();
  if (!secure || !facebookAppId) {
    // HTTP không https + ko localhost: fallback button disabled.
    // Người dùng vẫn nhìn thấy Facebook button (không làm layout vỡ) nhưng click không gọi SDK.
    // Nếu user click → show 1 toast hướng dẫn host phải https hoặc localhost.
    // KO gọi @greatsumini FacebookLogin component ở đây -> KO có FB SDK script inject
    // -> KO có warning FB.getLoginStatus mỗi khi App re-render (click logout/register).
    return (
      <button
        type="button"
        className="facebook_btn"
        disabled
        title="Đăng nhập Facebook yêu cầu trang chạy trên https:// hoặc localhost"
        onClick={() => {
          try {
            // eslint-disable-next-line no-alert
            window.alert('Đăng nhập Facebook chỉ hoạt động trên trang chạy https:// hoặc localhost.');
          } catch {
            /* ignore */
          }
        }}
      >
        <FacebookSvg />
        <span>Facebook</span>
      </button>
    );
  }
  return (
    <FacebookLogin
      className="facebook_btn"
      autoLoad={false}
      appId={facebookAppId}
      onFail={(e) => onError(e)}
      onSuccess={(e) => onSuccess(e, 'facebook')}
      render={(renderProps) => (
        <button type="button" className="facebook_btn" onClick={renderProps.onClick}>
          <FacebookSvg />
          <span>Facebook</span>
        </button>
      )}
    />
  );
}
